/**
 * TCPN PHASE 10-B2B TRUST1 — Canonical Verified-Provenance Copy
 * =============================================================
 * SINGLE source of truth for the wording rendered inside the "TreatX Verified"
 * provenance tooltip. NO surface may write its own copy — all three callers
 * (grid card, list card, public profile) import from this module.
 *
 * Wording rules (locked by phase brief):
 *   - factual only
 *   - no comparative or superlative claims
 *   - no implied medical / outcome / accreditation guarantees
 *   - explicit non-guarantee disclaimer
 */

export const VERIFICATION_COPY = Object.freeze({
  title: 'TreatX Verification',
  // Each item renders as a separate line in the tooltip body.
  body: Object.freeze([
    'Required provider documents have been reviewed by TreatX.',
    'Verification indicates platform review of submitted provider information and documents.',
    'Verification does not guarantee treatment outcomes.',
  ]),
  // Surfaces only receive these strings — no inline copy is allowed elsewhere.
});

/**
 * Predicate used by all three surfaces. Mirrors the backend truth — never
 * reconstructs verification state from unrelated fields.
 *   - grid/list card receives `clinic.verification_status` directly
 *   - public profile derives canonical `isVerified` from accreditation invariants
 *     (TCPN-MP0-F cutover) — legacy `badges.is_verified` is no longer consulted
 */
export const isVerifiedProvider = (verificationStatus) =>
  verificationStatus === 'verified';
